import { useForm, Form } from "em-form";
import Button from "components/Button";
import Cookies from "js-cookie";
import eventStop from "components/ReactUtils/eventStop";
import i18next, { t } from "translations/i18n";
import KaInput from "components/Form/KaInput";
import React, { useState, useEffect } from "react";
import styled from "react-emotion";

import "../../translations/funnel";
import Lightbox from "../Lightbox";
import useApi from "../../hooks/useApi";

import image from "./illustration.svg";

i18next.addResourceBundle("de", "exitpopup", {
  h1: "Du wünschst Beratung",
  h2:
    "Dann trage unten einfach deine Kontaktdaten ein, um unsere Fachberatung anzufordern. Wir werden uns sofort bei dir melden.",
  thankyou: "Vielen Dank für die Anmeldung!",
  email: "Deine E-Mail Adresse",
  phone: "Deine Telefonnummer",
  button: "Fachberatung anfordern",
});

i18next.addResourceBundle("en", "exitpopup", {
  h1: "Do you need assistance with your new kitchen?",
  h2:
    "Just fill out the form below to get in contact with one of our experts. We are going to contact you as soon as possible",
  thankyou: "Thank you for registering!",
  email: "Your e-mail address",
  phone: "Your phone number",
  button: "Request expert advice",
});

function addEvent(obj, evt, fn) {
  if (obj.addEventListener) {
    obj.addEventListener(evt, fn, false);
  } else if (obj.attachEvent) {
    obj.attachEvent("on" + evt, fn);
  }
}

function ExitPopup(props) {
  const [sent, setSent] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const api = useApi();
  const { showExitPopup } = props;

  useEffect(() => {
    if (showExitPopup && !Cookies.get("exitPopupShown")) {
      addEvent(document, "mouseout", e => {
        e = e || window.event;

        const from = e.relatedTarget || e.toElement;

        if (!from || from.nodeName === "HTML") {
          if (!Cookies.get("exitPopupShown")) {
            setOpen(true);
            Cookies.set(`exitPopupShown`, "true", { expires: 365 * 5 });
          }
        }
      });
    }
  }, []);

  const form = useForm({
    data: { email: "", phone: "" },
    constraints: {
      email: {
        presence: { message: t("funnel:constraints-email-add") },
        email: { message: t("funnel:constraints-email-fix") },
      },
      phone: {
        presence: {
          message: t("funnel:constraints-phone"),
        },
        length: {
          minimum: 6,
          message: t("funnel:constraints-phone"),
        },
      },
    },
  });

  const onSubmit = async e => {
    eventStop(e);

    if (!form.isValid) return;

    const paramsPreserve = window.localStorage.getItem("paramsPreserve")
      ? JSON.parse(window.localStorage.getItem("paramsPreserve"))
      : {};

    api.post("basicLeadSubmit", { ...form.data, paramsPreserve });

    setSent(true);
  };

  return (
    <Lightbox
      isOpen={isOpen}
      onClose={() => setOpen(false)}
      xtitle="Kein Angebot mehr nötig"
      contentClass={"stylesContent"}
    >
      <div className={props.className}>
        <div className="row">
          <div className="col-xs-6">
            <img src={image} alt="" />
          </div>
          {sent && (
            <div className="col-xs-6 thank-you">
              <h2>{t("exitpopup:thankyou")}</h2>
            </div>
          )}

          {!sent && (
            <div className="col-xs-6">
              <h2>{t("exitpopup:h1")}</h2>
              {t("exitpopup:h2")}
              <div className={"formBox"}>
                <Form {...form} onSubmit={onSubmit} className={"form"}>
                  <KaInput label={t("exitpopup:email")} type="text" name="email" />
                  <KaInput label={t("exitpopup:phone")} type="tel" name="phone" />

                  <Button type="submit" text={t("exitpopup:button")} className={"button"} />
                </Form>
              </div>
            </div>
          )}
        </div>
      </div>
    </Lightbox>
  );
}

ExitPopup = styled(ExitPopup)`
  .stylesContent {
    width: 95%;
    max-width: 950px;
  }

  .thank-you {
    margin-top: 60px;
  }
  form {
    margin-top: 1em;
    text-align: center;

    button {
      margin-top: 0.5em;
    }
  }
  img {
    max-width: 100%;
  }
`;

export default ExitPopup;
